import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
} from '@gousto-internal/citrus-react'

// Render as a pill when the screen is wide enough, otherwise render as a full-width bar
// The pill is used in the OrderConfirmationHeader, and the bar is used in the OrderConfirmation component
export const DISCOUNT_BANNER_BREAKPOINT_PX = 740

type DiscountSavingsBannerVariant = 'pill' | 'bar'

// 'light' is the light-green badge; 'dark' keeps the original dark-green banner colours
type DiscountSavingsBannerTone = 'light' | 'dark'

export type AppliedDiscount = {
  title: string
  subtitle: string
}

type DiscountSavingsBannerProps = AppliedDiscount & {
  variant: DiscountSavingsBannerVariant
  tone?: DiscountSavingsBannerTone
}

const TONE_COLOURS = {
  light: { background: Color.Success_50, text: Color.Success_900 },
  dark: { background: Color.Success_900, text: Color.White },
} as const

export const DiscountSavingsBanner = ({
  title,
  subtitle,
  variant,
  tone = 'light',
}: DiscountSavingsBannerProps) => {
  const isPill = variant === 'pill'
  const { background, text } = TONE_COLOURS[tone]

  return (
    <Box
      data-testid={isPill ? 'discountSavingsPill' : 'discountSavingsBar'}
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={1}
      paddingH={2}
      bg={background}
      color={text}
      width={isPill ? undefined : '100%'}
      style={{
        borderRadius: '4px',
        paddingTop: '2px',
        paddingBottom: '2px',
        whiteSpace: isPill ? 'nowrap' : undefined,
      }}
    >
      <Icon name="tick" size={4} variant={IconVariant.Inherit} />
      <Body2 size={2} fontWeight={FontWeight.Bold} color={text}>
        {title}
      </Body2>
      <Body2 size={2} color={text} aria-hidden="true">
        •
      </Body2>
      <Body2 size={2} color={text}>
        {subtitle}
      </Body2>
    </Box>
  )
}
